export const addEditTypes = {
    DP: "Data Provider",
    DP_SERVICE: "DP Service",
    DP_SOURCE: "DP Source",
}

export const addEditDPActionTypes = {
    CREATE_DP_MODAL: "CREATE_DP_MODAL",
    EDIT_DP_MODAL: "EDIT_DP_MODAL",
    CLOSE_DP_MODAL: "CLOSE_DP_MODAL",
    SETTING_DP_FORM_OBJECT_VALUE: "SETTING_DP_FORM_OBJECT_VALUE",
    UPDATE_DP_CONTACT: "UPDATE_DP_CONTACT",
    VALIDATE_DATA_PROVIDER_FORM: "VALIDATE_DATA_PROVIDER_FORM",
    UPDATED_DP_REFRESH: "UPDATED_DP_REFRESH",
}

export const addEditDPServiceActionTypes = {
    CREATE_DP_SERVICE_MODAL: "CREATE_DP_SERVICE_MODAL",
    EDIT_DP_SERVICE_MODAL: "EDIT_DP_SERVICE_MODAL",
    CLOSE_DP_SERVICE_MODAL: "CLOSE_DP_SERVICE_MODAL",
    UPDATED_DP_SERVICE_REFRESH: "UPDATED_DP_SERVICE_REFRESH",

    VALIDATE_DP_SERVICE_FORM: "VALIDATE_DP_SERVICE_FORM",
    SETTING_DPSERVICE_FORM_OBJECT_VALUE: "SETTING_DPSERVICE_FORM_OBJECT_VALUE",

    ADD_NEW_REQUIRED_INPUT_GROUP: "ADD_NEW_REQUIRED_INPUT_GROUP",
    EDIT_EXISTING_INPUT_GROUP: "EDIT_EXISTING_INPUT_GROUP",
    DELETE_SELECTED_INPUT_GROUP: "DELETE_SELECTED_INPUT_GROUP",

    PREP_INPUT_KEYS: "FORMATTING_INPUT_KEYS",
    MARK_AS_PRIMARY_SERVICE_CONFIG_NAME: "MARK_AS_PRIMARY_SERVICE_CONFIG_NAME",
    ADD_TO_SELECTED_SERVICE_CONFIG_NAMES: "ADD_TO_SELECTED_SERVICE_CONFIG_NAMES",
    ADD_TO_ASSOCIATED_SERVICE_CONFIG_NAMES: "ADD_TO_ASSOCIATED_SERVICE_CONFIG_NAMES",
    DELETE_FROM_ASSOCIATED_SERVICE_CONFIG_NAMES: "DELETE_FROM_ASSOCIATED_SERVICE_CONFIG_NAMES",

    SELECT_BILLING_GROUP: "SELECT_BILLING_GROUP",
    SELECT_DATA_PROVIDER: "SELECT_DATA_PROVIDER",
    UPDATE_DP_TYPE_INTEGRATION_STATUS: "UPDATE_DP_TYPE_INTEGRATION_STATUS",
    SELECT_SERVICE_SET: "SELECT_SERVICE_SET",

    UPDATE_DP_SERVICE_NOTES: "UPDATE_DP_SERVICE_NOTES",
    UPDATE_DP_SERVICES_CONTACT: "UPDATE_DP_SERVICES_CONTACT"
}

export const addEditDPSourceActionTypes = {
    CREATE_DP_SOURCE_MODAL: "CREATE_DP_SOURCE_MODAL",
    EDIT_DP_SOURCE_MODAL: "EDIT_DP_SOURCE_MODAL",
    CLOSE_DP_SOURCE_MODAL: "CLOSE_DP_SOURCE_MODAL",

    UPDATED_DP_SOURCE_REFRESH: "UPDATED_DP_SOURCE_REFRESH",

    SETTING_DPSOURCE_FORM_OBJECT_VALUE: "SETTING_DPSOURCE_FORM_OBJECT_VALUE",
    SETTING_ASSOCIATED_SERVICE_OPTION: "SETTING_ASSOCIATED_SERVICE_OPTION",
    SETTING_ASSOCIATED_COUNTRY_OPTION: "SETTING_ASSOCIATED_COUNTRY_OPTION",
    SETTING_VERIFIABLE_INPUT_VALUE: "SETTING_VERIFIABLE_INPUT_VALUE",

    TOGGLE_RESULT_OPTION: "TOGGLE_RESULT_OPTION",
    TOGGLE_CONSENT_VALUE: "TOGGLE_CONSENT_VALUE",
    TOGGLE_VERIFIABLE_INPUT_OPTIONS: "TOGGLE_VERIFIABLE_INPUT_OPTIONS",
    EDIT_VERIFIABLE_INPUT: "EDIT_VERIFIABLE_INPUT",
    ADDING_VERIFIABLE_INPUT: "ADDING_VERIFIABLE_INPUT",
    DELETING_VERIFIABLE_INPUT: "DELETING_VERIFIABLE_INPUT",
    VALIDATE_DP_SOURCE_FORM: "VALIDATE_DP_SOURCE_FORM",
}

export const addEditCountryActionTypes = {
    ADD_COUNTRY: "ADD_COUNTRY",
    EDIT_ONE_COUNTRY: "EDIT_ONE_COUNTRY",
    TOGGLE_MODAL: "TOGGLE_MODAL",
    SET_COUNTRY: "SET_COUNTRY",
    SET_COUNTRY_DROPDOWNS: "SET_COUNTRY_DROPDOWNS",
    SET_COUNTRY_PRODUCT_SUPPORT: "SET_COUNTRY_PRODUCT_SUPPORT",
    SET_MATCH_RATES: "SET_MATCH_RATES",
    VALIDATE_COUNTRY_FORM: "VALIDATE_COUNTRY_FORM",
    UPDATED_COUNTRY_REFRESH: "UPDATED_COUNTRY_REFRESH",
}

export const addEditBillingGroupActionTypes = {
    ADD_BILLING_GROUP: "ADD_BILLING_GROUP",
    EDIT_ONE_BILLING_GROUP: "EDIT_ONE_BILLING_GROUP",
    TOGGLE_MODAL: "TOGGLE_MODAL",
    SETTING_BILLING_GROUP_FORM_OBJECT_VALUE: "SETTING_BILLING_GROUP_FORM_OBJECT_VALUE",
    SETTING_BILLING_GROUP_FORM_DESCRIPTION: "SETTING_BILLING_GROUP_FORM_DESCRIPTION",
    SET_BILLING_GROUP_DROPDOWNS: "SET_BILLING_GROUP_DROPDOWNS",
    SET_BILLING_GROUP_TOGGLES: "SET_BILLING_GROUP_TOGGLES",
    SET_BILLING_GROUP_DATE: "SET_BILLING_GROUP_DATE",
    VALIDATE_BILLING_GROUP_FORM: "VALIDATE_BILLING_GROUP_FORM",
    UPDATED_BILLING_GROUP_REFRESH: "UPDATED_BILLING_GROUP_REFRESH",
}
